import { render, staticRenderFns } from "./LinkedName.vue?vue&type=template&id=546b846a"
import script from "./LinkedName.vue?vue&type=script&lang=js"
export * from "./LinkedName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports